// extracted by mini-css-extract-plugin
module.exports = {"root":"Input_root__On9vr","label":"Input_label__CR3VX"};